module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-MediumItalic.58316afc.eot";